<template>
  <div class="member_tabbar">
    <a href="javascript:;" v-for="item in list" :key="`cur${item.name}`" :class="{'active': item.id == curTitleId}" @click="changeTitle(item)">{{item.name}}<i></i></a>
  </div>
</template>

<script>
  export default {
    data: function () {
      return {}
    },
    props: {
      list: {
        type: Array,
        default : []
      },
      curTitleId: {
        type: Number,
        default : 1
      }
    },
    methods:{
      changeTitle(item){
        this.$emit('titleChange', item.id)
      }
    }
  }
</script>

<style scoped>
.member_tabbar a{
  width: 100px
}
.member_tabbar a.active i{
    left: 34px;
}
</style>



// WEBPACK FOOTER //
// src/common/accnav.vue